import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import "./Form3.css";

const Form3 = () => {
  const navigate = useNavigate();

  const [formData, setFormData] = useState({
    adults: "",
    children: "",
    infants: "",
    travelType: "",
    theme: "",
  });

  const [errors, setErrors] = useState({});

  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value,
    });
  };

  const handleSelect = (field, value) => {
    setFormData({
      ...formData,
      [field]: value,
    });
  };

  const validate = () => {
    let err = {};

    if (!formData.adults || formData.adults <= 0) {
      err.adults = "Enter valid number of adults";
    }

    if (formData.children === "") {
      err.children = "Enter number of children";
    }

    if (formData.infants === "") {
      err.infants = "Enter number of infants";
    }

    if (!formData.travelType) {
      err.travelType = "Select travel type";
    }

    if (!formData.theme) {
      err.theme = "Select tour theme";
    }

    setErrors(err);
    return Object.keys(err).length === 0;
  };


    const handleSubmit = (e) => {
      e.preventDefault();

      const isValid = validate();

      if (isValid) {
        navigate("/form4");
      }
    };

  return (
    <div className="traveller-main">
      <div className="left-section">
        <h1>Traveller Details</h1>
      </div>

      <div className="right-section">
        <form onSubmit={handleSubmit} className="traveller-form">
          <label>Number of Adults</label>
          <input
            type="number"
            name="adults"
            placeholder="Enter number of adults"
            value={formData.adults}
            onChange={handleChange}
          />
          {errors.adults && <p className="error">{errors.adults}</p>}

          <label>Number of Children (with age)</label>
          <input
            type="number"
            name="children"
            placeholder="Enter number of children with their ages"
            value={formData.children}
            onChange={handleChange}
          />
          {errors.children && <p className="error">{errors.children}</p>}

          <label>Number of Infants (0–2 Years)</label>
          <input
            type="number"
            name="infants"
            placeholder="Enter number of infants"
            value={formData.infants}
            onChange={handleChange}
          />
          {errors.infants && <p className="error">{errors.infants}</p>}

          <label>Type of Travel</label>
          <div className="button-group">
            {["Couple", "Family", "Group", "Corporate"].map((item) => (
              <button
                type="button"
                key={item}
                className={`select-btn ${
                  formData.travelType === item ? "active" : ""
                }`}
                onClick={() => handleSelect("travelType", item)}
              >
                {item}
              </button>
            ))}
          </div>
          {errors.travelType && <p className="error">{errors.travelType}</p>}

          <label>Tour Type / Theme</label>
          <div className="button-group">
            {[
              "Weekend Getaway",
              "Honeymoon",
              "Family Holiday",
              "Adventure",
              "Religious",
            ].map((item) => (
              <button
                type="button"
                key={item}
                className={`select-btn ${
                  formData.theme === item ? "active" : ""
                }`}
                onClick={() => handleSelect("theme", item)}
              >
                {item}
              </button>
            ))}
          </div>
          {errors.theme && <p className="error">{errors.theme}</p>}

          <div className="navigation-buttons">
            <button
              type="button"
              className="back-btn"
              onClick={() => navigate(-1)}
            >
              Back
            </button>

            <button type="submit" className="next-btn">
              Next
            </button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default Form3;
